import Vue from "vue";
import VueResource from "vue-resource";
import GlobalSearch from "@search/app/global-search";

export const globalsearch = {
    init: () => {
        Vue.use(VueResource);
        import("@search/store/searchStore")
            .then(({searchStore}) => {

                const searchShell = document.getElementById('global-search');
                new Vue({
                    store: searchStore,
                    render: h => h(GlobalSearch, {
                        props: {
                            searchUrl: searchShell.dataset.searchurl,
                        }
                    })
                }).$mount(searchShell);
            });
    }
}
